// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2msNC","options":"AnswerScale_options__1fw1c","selected":"AnswerScale_selected__2AmX8"};